import * as React from 'react';

import { CertificateIcon, GlobeIcon, ReadingIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/degree-description';

export type StackabilityDummyContent = {
  heading: string;
  description: string;
  valueProps: {
    icon: React.ReactNode;
    headline: string;
    description: string;
  }[];
};

export const getStackabilityDummyContent = (): StackabilityDummyContent => ({
  heading: _t('Begin with degree coursework today'),
  description: _t(
    'With Coursera Plus, access courses from participating degree programs and build progress toward your future degree.'
  ),
  valueProps: [
    {
      icon: <ReadingIcon size="medium" />,
      headline: _t('Start learning with Coursera Plus'),
      description: _t(
        'Get unlimited access to courses from participating degree programs with a Coursera Plus subscription.'
      ),
    },
    {
      icon: <CertificateIcon size="medium" />,
      headline: _t('Earn credits before you apply'),
      description: _t("Complete eligible courses to earn credit that can count toward your degree if you're admitted."),
    },
    {
      icon: <GlobeIcon size="medium" />,
      headline: _t('No commitment required'),
      description: _t('Explore the subject and see if the degree is right for you before you commit to applying.'),
    },
  ],
});
